export default __webpack_public_path__ + "cb917f2da37c8efccf88ffbe768ac762.png";